// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"j6dZ1","ValidateArea":"MGGTW","ValidateButton":"pZIUC"};